import ReactMarkdown from 'react-markdown';
import LogoSprite from './LogoSprite';

const Claim = ({ subtitle, claim }) => {
  const renderSubtitle = () => {
    const keyword = 'instalación de';
    const index = subtitle.toLowerCase().indexOf(keyword);

    if (index === -1) return subtitle;

    const before = subtitle.slice(0, index + keyword.length);
    const after = subtitle.slice(index + keyword.length);

    return (
      <>
        <span className="font-light text-2xl">{before}</span>
        <strong className="font-black text-3xl">{after}</strong>
      </>
    );
  };

  return (
    <div className="flex flex-col md:flex-row md:gap-16 mb-16 justify-center text-center md:text-left relative z-10">
      <h2 className="text-slate-700 mb-8 text-center md:text-right flex flex-col gap-1">
        {renderSubtitle()}
      </h2>

      <div className="max-w-lg mx-auto md:mx-0 claim">
        <ReactMarkdown>{claim}</ReactMarkdown>
      </div>

      <LogoSprite id="imago-plain" className="absolute -z-10 w-full h-full fill-slate-50" />
    </div>
  );
};

export default Claim;
